import { Directive } from '@angular/core';

@Directive({
  // eslint-disable-next-line
  selector: 'app-error-page-action',
})
export class ErrorPageActionDirective {
}
